import { CheckIcon, XIcon } from "lucide-react";

export interface ValidationRuleProps {
  isValid: boolean;
  label: string;
}

export function ValidationRule({ isValid, label }: ValidationRuleProps) {
  return (
    <div className="flex items-center gap-2 text-xs">
      {isValid ? (
        <CheckIcon className="h-3.5 w-3.5 text-emerald-600 flex-shrink-0" />
      ) : (
        <XIcon className="h-3.5 w-3.5 text-muted-foreground flex-shrink-0" />
      )}
      <span className={isValid ? "text-emerald-700" : "text-muted-foreground"}>
        {label}
      </span>
    </div>
  );
}
